// extracted by mini-css-extract-plugin
export default {"href":"Logo_href__s4PVJ","logo":"Logo_logo__W9EYC","title":"Logo_title__G4gi6"};